var map = {
	"./undraw_chapter1.png": 9462,
	"./undraw_chapter2.png": 3437,
	"./undraw_chapter3.png": 9540,
	"./undraw_chapter4.png": 3403,
	"./undraw_chapter5.png": 8578,
	"./undraw_chapter6.png": 9545
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5568;